<template>
    <div>
        <v-bottom-sheet v-model="$store.state.UniversityAppData.universityApp">
            <v-sheet class="text-center mx-auto">
                <div class="py-3">
                    <v-row class="justify-center d-flex d-flex-row ml-3 pa-6">
                        <v-col cols="6" md="2" sm="3" xs="3" class="">
                            <a href="https://usosweb.ans.edu.pl/">
                                <v-card
                                    elevation="3"
                                    class="flexcard"
                                    height="100%"
                                >
                                    <v-img
                                        class="ml-3"
                                        :src="
                                            'https://usosweb.ans.edu.pl/kontroler.php?_action=common/getLocalStatic&file=logo.png&mtime=1357806952'
                                        "
                                        max-height="80px"
                                        max-width="240px"
                                    ></v-img>
                                    <v-card-text
                                        >System obsługi studenta<br />
                                        USOSweb<br
                                    /></v-card-text>
                                    <v-card-actions class="justify-center">
                                        <v-btn
                                            outlined
                                            icon
                                            elevation="2"
                                            large
                                            :href="'https://usosweb.ans.edu.pl/'"
                                        >
                                            <v-icon>mdi-login</v-icon>
                                        </v-btn>
                                    </v-card-actions>
                                </v-card>
                            </a>
                        </v-col>

                        <v-col cols="6" md="2" sm="2" xs="3" class="">
                            <a href="https://outlook.com/">
                                <v-card
                                    elevation="3"
                                    class="flexcard"
                                    height="100%"
                                >
                                    <v-img
                                        class="ml-2"
                                        :src="'/images/outlook.png'"
                                        max-height="80px"
                                        max-width="240px"
                                    ></v-img>
                                    <v-card-text
                                        >Uczelniana poczta
                                        elektroniczna</v-card-text
                                    >

                                    <v-card-actions class="justify-center">
                                        <v-btn
                                            outlined
                                            icon
                                            elevation="2"
                                            large
                                        >
                                            <v-icon>mdi-login</v-icon>
                                        </v-btn>
                                    </v-card-actions>
                                </v-card>
                            </a>
                        </v-col>
                        <v-col cols="6" md="2" sm="2" xs="3" class="">
                            <a href="https://katalog.ans.edu.pl">
                                <v-card
                                    elevation="3"
                                    class="flexcard"
                                    height="100%"
                                >
                                    <v-img
                                        :src="'/images/koha.png'"
                                        max-height="80px"
                                        max-width="240px"
                                        aria-label="System biblioteczny KOHA"
                                    ></v-img>
                                    <v-card-text
                                        >System biblioteczny</v-card-text
                                    >
                                    <v-card-actions class="justify-center">
                                        <v-btn
                                            outlined
                                            icon
                                            elevation="2"
                                            large
                                        >
                                            <v-icon>mdi-login</v-icon>
                                        </v-btn>
                                    </v-card-actions>
                                </v-card>
                            </a>
                        </v-col>
                                    <v-col cols="6" md="2" sm="3" xs="3" class="">
                                        <a href="https://infopracownik.ans.edu.pl/">
                                            <v-card elevation="3" class="flexcard" height="100%">
                                                <v-img class="ml-3" :src="'/images/info-Pracownik.svg'" max-height="80px" max-width="240px"></v-img>
                                                <v-card-text>Informacje bieżące -
                                                    pracownik</v-card-text>
                                                <v-card-actions class="justify-center">
                                                    <v-btn outlined icon elevation="2" large>
                                                        <v-icon>mdi-login</v-icon>
                                                    </v-btn>
                                                </v-card-actions>
                                            </v-card>
                                        </a>
                                    </v-col>
                        <v-col cols="6" md="2" sm="2" xs="3" class="">
                            <a href="https://moodle.ans.edu.pl/">
                                <v-card
                                    elevation="3"
                                    class="flexcard"
                                    height="100%"
                                >
                                    <v-img
                                        class="pa-6"
                                        :src="'/images/moodle.png'"
                                        max-height="80px"
                                        max-width="240px"
                                    ></v-img>
                                    <v-card-text>Nauczanie zdalne</v-card-text>
                                    <v-card-actions class="justify-center">
                                        <v-btn
                                            outlined
                                            icon
                                            elevation="2"
                                            large
                                            :href="'https://moodle.ans.edu.pl/'"
                                        >
                                            <v-icon>mdi-login</v-icon>
                                        </v-btn>
                                    </v-card-actions>
                                </v-card>
                            </a>
                        </v-col>


                    </v-row>
                </div>
            </v-sheet>
        </v-bottom-sheet>
    </div>
</template>
<script>
export default {
    data() {
        return {
            universityApp: false
        };
    }
};
</script>

<style scoped>
a {
    text-decoration: none;
}
</style>
